var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-title",class:_vm.type},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.sTitle),expression:"sTitle"}],staticClass:"s_title"},[_vm._v(_vm._s(_vm.sTitle))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460c6ca5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/moduleTitle.vue
// module id = null
// module chunks = 